import _jsx from "@babel/runtime/helpers/jsx";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _class, _class2, _ChevronLeftIcon, _ChevronRightIcon;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import classNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import withStyles from 'isomorphic-style-loader/withStyles';
import isLoggedIn from '../../helpers/checkAuth';
import messages from '../../routes/quizzes/quizResult/quizResultMessages'; // todo create a separate lang file
import s from './SectionItemNavigationMenu.scss';
import LessonsListItem from '../LessonsListItem/LessonsListItem';
import QuizzesListItem from '../QuizzesListItem/QuizzesListItem';
import intlPropTypes from '../../constants/intlPropTypes';
import { getFirstForcedProgressionItem, isItemBlockedByApprovalStep, isItemDisabledByForcedProgression } from '../../helpers/forcedProgression';
var getVisibleSections = function getVisibleSections(course) {
  return _.filter(_.get(course, 'sections', []), function (section) {
    return !section.isContentHidden;
  });
};
var SectionItemNavigationMenu = (_dec = withStyles(s), _dec2 = connect(function (state) {
  return {
    auth: state.auth
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(SectionItemNavigationMenu, _React$Component);
  var _super = _createSuper(SectionItemNavigationMenu);
  function SectionItemNavigationMenu() {
    var _this;
    _classCallCheck(this, SectionItemNavigationMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentSectionIndex: _.findIndex(getVisibleSections(_this.props.course), function (section) {
        return !!_.find(_.get(section, 'items', []), function (item) {
          return _.get(item, 'item._id') === _this.props.currentItemId;
        });
      })
    });
    _defineProperty(_assertThisInitialized(_this), "nextSection", function () {
      var currentSectionIndex = _this.state.currentSectionIndex;
      var course = _this.props.course;
      if (currentSectionIndex !== getVisibleSections(course).length - 1) {
        _this.setState({
          currentSectionIndex: currentSectionIndex + 1
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "prevSection", function () {
      var currentSectionIndex = _this.state.currentSectionIndex;
      if (currentSectionIndex) {
        _this.setState({
          currentSectionIndex: currentSectionIndex - 1
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderSection", function (section, index) {
      var currentSectionIndex = _this.state.currentSectionIndex;
      var _this$props = _this.props,
        course = _this$props.course,
        formatMessage = _this$props.intl.formatMessage,
        auth = _this$props.auth;
      var completedLessons = formatMessage(messages.completedItemsInSection, {
        completedLessons: section.completedLessons,
        completedQuizzes: section.completedQuizzes,
        totalLessons: section.totalLessons,
        totalQuizzes: section.totalQuizzes
      });
      return /*#__PURE__*/_jsx("div", {
        className: s.section
      }, section._id, /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "X4OFRW8tkRK8y-LdgBE67",
        onClick: _this.prevSection,
        disabled: !index
      }, void 0, _ChevronLeftIcon || (_ChevronLeftIcon = /*#__PURE__*/_jsx(ChevronLeftIcon, {}))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.flex1, s.flex, s.spaceBetween, s.flexStart)
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.sectionName
      }, void 0, section.name), isLoggedIn(auth) && /*#__PURE__*/_jsx(Tooltip, {
        title: completedLessons
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.sectionStat
      }, void 0, section.completedLessons + section.completedQuizzes, " /", ' ', section.totalLessons + section.totalQuizzes))), /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "LRLmjBoPB5JgulnM3zOR7",
        onClick: _this.nextSection,
        disabled: currentSectionIndex === getVisibleSections(course).length - 1
      }, void 0, _ChevronRightIcon || (_ChevronRightIcon = /*#__PURE__*/_jsx(ChevronRightIcon, {}))));
    });
    _defineProperty(_assertThisInitialized(_this), "renderItems", function (section) {
      var course = _this.props.course;
      var firstIncompleteItem = getFirstForcedProgressionItem(course);
      return _(section.items).map(function (sectionItem) {
        if (sectionItem.itemType === 'Lesson') {
          return /*#__PURE__*/_jsx(LessonsListItem, {
            item: _.get(sectionItem, 'item', {}),
            course: _this.props.course,
            active: _.get(sectionItem, 'item._id') === _this.props.currentItemId,
            isCompleted: sectionItem.isCompleted,
            disabled: isItemBlockedByApprovalStep(course, sectionItem) || isItemDisabledByForcedProgression(course, sectionItem, firstIncompleteItem)
          }, "".concat(section._id, "_").concat(_.get(sectionItem, 'item._id', '')));
        }
        if (sectionItem.itemType === 'Quiz') {
          return /*#__PURE__*/_jsx(QuizzesListItem, {
            item: _.get(sectionItem, 'item', {}),
            course: _this.props.course,
            active: _.get(sectionItem, 'item._id') === _this.props.currentItemId,
            isCompleted: sectionItem.isCompleted,
            disabled: isItemBlockedByApprovalStep(course, sectionItem) || isItemDisabledByForcedProgression(course, sectionItem, firstIncompleteItem)
          }, "".concat(section._id, "_").concat(_.get(sectionItem, 'item._id', '')));
        }
        return null;
      }).value();
    });
    return _this;
  }
  _createClass(SectionItemNavigationMenu, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.currentItemId !== nextProps.currentItemId) {
        this.setState({
          currentSectionIndex: _.findIndex(getVisibleSections(nextProps.course), function (section) {
            return !!_.find(_.get(section, 'items', []), function (item) {
              return _.get(item, 'item._id') === nextProps.currentItemId;
            });
          })
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        isMenuOpen = _this$props2.isMenuOpen,
        menuAnchorEl = _this$props2.menuAnchorEl,
        handleMenuClose = _this$props2.handleMenuClose,
        course = _this$props2.course;
      var currentSectionIndex = this.state.currentSectionIndex;
      return /*#__PURE__*/_jsx(Popover, {
        open: isMenuOpen,
        anchorEl: menuAnchorEl,
        anchorReference: "anchorEl",
        onClose: handleMenuClose,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center'
        },
        classes: {
          paper: s.popover
        }
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: s.popoverContent
      }, void 0, getVisibleSections(course).map(function (section, index) {
        return /*#__PURE__*/_jsx("div", {
          className: currentSectionIndex === index ? '' : s.hidden
        }, section._id, !course.hideSectionTitle && _this2.renderSection(section, index), /*#__PURE__*/_jsx(List, {
          component: "div",
          disablePadding: true,
          className: s.list
        }, void 0, _this2.renderItems(section)));
      })));
    }
  }]);
  return SectionItemNavigationMenu;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  menuAnchorEl: undefined
}), _class2)) || _class) || _class) || _class);
export { SectionItemNavigationMenu as default };